<section [formGroup]="formGroup">
	<mat-checkbox formControlName="isMandatory">Is required</mat-checkbox>
</section>
